import React, { useEffect, useState, useRef } from "react";
import './Publishing.css'
import { Link, useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie';
import { Trans, useTranslation } from 'react-i18next'
import BtnTopLeft from './../../../images/btntopleft.png'
import BtnBottomRight from './../../../images/btnbottonright.png'
import Footer from "../../Footer/Footer";
import N3rveLogo from './../../../images/N3rveLogo.png'
import WorldCollectionHybrid from "../../Hybrid/WorldCollectionHybrid";
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';
import { logtoWix } from "../../Helpers/LogToWix";
import { useJwt, decodeToken } from "react-jwt";


function Publishing() {

    const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
    const navigate = useNavigate()
    const cookies = new Cookies(null, { path: '/' });
    const hasLogged = useRef(false);

    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    useEffect(() => {
        topFunction()
        if (!hasLogged.current) {
            if (cookies.get('token') !== undefined) {
                if (decodeToken(cookies.get('token')) !== null) {
                    logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Publishing Page", { "desc": "User opened the publishing page" })
                    hasLogged.current = true;
                } else {
                    logtoWix("anonymous user", "pageview", "Publishing Page", { "desc": "User opened the publishing page" })
                    hasLogged.current = true;
                }
            } else {
                logtoWix("anonymous user", "pageview", "Publishing Page", { "desc": "User opened the publishing page" })
                hasLogged.current = true;
            }
        }
    }, [])


    return (
        <div>
            <WorldCollectionHybrid />

            <div style={{
                backgroundColor: `rgba(0,0,0,100%)`,
                backgroundImage: 'linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0.42) 0.01%, #100101 100%)',
                height: '24.43em',
                width: '100%',
                backgroundSize: 'cover',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>

                <div className="SubmitYourProject">Ready to Secure Your Earnings?</div>
                <div className="FillOutForm">Join our community of talented artists and producers, and let's make music that moves the world.</div>

                <div className="WCFormSubmit" onClick={() => navigate('/Signup')}>
                    SIGN UP
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1.5em' }}>
                    <div style={{ width: '10px', height: '3px', marginRight: '12px', backgroundColor: '#868284' }} />
                    <div style={{ width: '10px', height: '3px', marginRight: '12px', backgroundColor: '#868284' }} />
                    <div style={{ width: '44px', height: '3px', marginRight: '12px', backgroundColor: '#868284' }} />
                </div>
            </div>

            <Footer />

        </div>
    );
}

export default Publishing;